import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormControlName, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-cancel-order-reasons',
  templateUrl: './cancel-order-reasons.component.html',
  styleUrls: ['./cancel-order-reasons.component.scss'],
  animations: [
    trigger('showHide', [
      transition(':enter',
        [
          style({ transform: 'translateY(-20px)', opacity: 0 }),
          animate(200, style({ transform: 'translateY(0px)', opacity: 1 })),
        ]),
      transition(':leave',
        [
          animate(200, style({ transform: 'translateY(-20px)', opacity: 0 })),
        ]),
    ]),
  ]
})
export class CancelOrderReasonsComponent implements OnInit {

  heading: string;
  reasons: [] = [];
  selectedReason: number;
  otherReason: FormControl = new FormControl('', Validators.required)
  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _MatSnackBar: MatSnackBar,
    public _matDialogRef: MatDialogRef<CancelOrderReasonsComponent>,
  ) {
    this.heading = this._data.heading;
    this.reasons = this._data.reasons;
  }

  ngOnInit(): void {
  }

  public onSubmit() {
    // console.log("selectedReason", this.selectedReason);
    // console.log("otherReason", this.otherReason);
    if (!this.selectedReason) {
      this._MatSnackBar.open('Please Select the reason for conceling your order', 'OKAY', { duration: 3000 })
    } else if (this.selectedReason == 10 && this.otherReason.invalid) {
      this._MatSnackBar.open('Please provide a valid reason.', 'OKAY', { duration: 3000 })
      this.otherReason.markAsTouched();
    } else {
      const selectedReasonItem: any = this.reasons.filter((item: any) => item.id == this.selectedReason)[0];
      const params = {
        orderId: null, // order ki id
        remarks: selectedReasonItem.id == 10 ? this.otherReason.value : selectedReasonItem.title
      }
      this._matDialogRef.close(params)
    }
  }

}
